import { configureStore } from '@reduxjs/toolkit';
import currentUserReducer from './userReducer';
import cartReducer from './cartSlice';
// Import existing reducers from the old index.js
import connectionStatus from './connectionStatus';
import boatrbo from './boatrbo';
import listBoatsReducer from './listBoatsReducer';
// DEFINITIVE FIX: Import the new, dedicated selectBoatReducer.
import selectBoatReducer from './selectBoatReducer';
import { bookingCardReducer } from './boatReducers';
import similarBoatsReducer from './similarBoatsReducer';
import checkoutDataReducer from './checkOutDataReducer';
import userProfileReducer from './userProfileReducer';
import conversationReducer from './conversationReducer';
import authReducer from './authReducer';

const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
    auth: authReducer,
    connectionStatus: connectionStatus,
    boatrbo: boatrbo,
    boatList: listBoatsReducer, // Use 'boatList' to match the useSelector in the component
    selectBoat: selectBoatReducer,
    cart: cartReducer,
    similarBoats: similarBoatsReducer,
    bookingCard: bookingCardReducer,
    checkoutData: checkoutDataReducer,
    userProfile: userProfileReducer,
    conversation: conversationReducer,
  },
});

export default store;
